<div class="table-header">
  <span>Visual Roaming Agreements Peering Matrix</span>
</div>
<div class="matrix-table-panel">
  <table id="visual-peering-matrix">
    <thead>
      <tr>
        <th></th>
        <th *ngFor="let ns of roamingAgreementPeerings.allNetworkServers"><div style='width: 80px; word-break: break-all;'>{{ns.name}}</div></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let nsB of roamingAgreementPeerings.allNetworkServers">
        <td><div style="height: 30px;">{{nsB.name}}</div></td>
        <td *ngFor="let nsA of roamingAgreementPeerings.allNetworkServers"><div><i *ngIf="hasAgreementFromTo(nsA, nsB)" class="fa fa-check-circle" aria-hidden="true"></i></div></td>
      </tr>
    </tbody>
  </table>
</div>
